import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { CHECKIN_ROUTES } from '@conf/routes.config';

/**
 * コンポーネントの再利用処理を定義する。
 * 基本的には、Angular v14デフォルト動作と同じように自画面への遷移は再利用する方針。
 * （URLが変わる場合などは再利用されない。）
 *
 * ただし一部、意図的に自画面（同じURL）を呼び出して再描画させるパターンを実現するため、
 * そのパターンにおいてコンポーネントの再生成がされるようにする。
 *
 * @implements {RouteReuseStrategy}
 */
export class CheckinRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;

    // NOTE: Angular v14 で手を加えずビルドした場合は下記の処理。
    // return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // NOTE: Angular v14 で手を加えずビルドした場合は処理なし。
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;

    // NOTE: Angular v14 で手を加えずビルドした場合は下記の処理。
    // return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;

    // NOTE: Angular v14 で手を加えずビルドした場合は下記の処理。
    // return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    /** 再利用を許可しない遷移パターン */
    const notReusePaths = [{ from: CHECKIN_ROUTES.seatmap, to: CHECKIN_ROUTES.seatmap }];

    const isReusePath = !notReusePaths.some((path) => {
      return curr.routeConfig?.path === path.from && future.routeConfig?.path === path.to;
    });
    return future.routeConfig === curr.routeConfig && isReusePath;

    // NOTE: Angular v14 で手を加えずビルドした場合は下記の処理。
    // return future.routeConfig === curr.routeConfig;
  }
}
